var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M20 12.2747C20 12.6544 19.7178 12.9681 19.3518 13.0178L19.25 13.0247L4.25 13.0247C3.83579 13.0247 3.5 12.6889 3.5 12.2747C3.5 11.895 3.78215 11.5812 4.14823 11.5315L4.25 11.5247L19.25 11.5247C19.6642 11.5247 20 11.8604 20 12.2747Z",
    fill: "#082A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M10.828 17.7675C11.1215 18.0598 11.1226 18.5347 10.8303 18.8282C10.5646 19.095 10.148 19.1201 9.85392 18.9029L9.76964 18.8305L3.71964 12.8065C3.452 12.54 3.42766 12.1219 3.64661 11.8278L3.7196 11.7436L9.7696 5.71857C10.0631 5.42629 10.538 5.42727 10.8303 5.72077C11.096 5.98759 11.1193 6.4043 10.9009 6.69746L10.8281 6.78143L5.31203 12.2753L10.828 17.7675Z",
    fill: "#082A51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.ae693526e2a8f45c4c62b6d535d83c43.svg";
export { ForwardRef as ReactComponent };